<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'App',
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.redirectBasedOnWidth(); // 初始加载时检查
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    windowWidth(newWidth) {
      this.redirectBasedOnWidth();
    }
  },
  methods: {
    handleResize: _.debounce(function() {
      this.windowWidth = window.innerWidth;
    }, 200),
    
    redirectBasedOnWidth() {
      const isMobile = this.windowWidth < 768;
      const currentRoute = this.$route.path;
      
      // 只在首页路由时进行跳转判断
      if (currentRoute === '/' || currentRoute === '/newhome') {
        if (isMobile && currentRoute !== '/newhome') {
          this.$router.push('/newhome');
        } else if (!isMobile && currentRoute !== '/') {
          this.$router.push('/');
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
